import { render } from "./JudgeAffiliation.vue?vue&type=template&id=695de83c"
import script from "./JudgeAffiliation.vue?vue&type=script&lang=js"
export * from "./JudgeAffiliation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__